<template>
  <!-- Row -->
  <div class="task-screen row">
    <page-header :title="$t('app.tasks.title')"/>
    <div class="row mt-20">
      <div class="col-sm-6">
        <search-input
          :placeholder="$t('app.tasks.search_input_placeholder')"
          @input="search"
          class="task-search-field"
        />
      </div>
      <div class="col-sm-6 text-right button-row">
        <base-button
          :forTasks="true"
          :title="!calendarView ? this.$t('app.tasks.calendarView') : this.$t('app.tasks.listView')"
          classNames="btn btn-primary btn-sm btn-block button-rounded right-button"
          @clicked="changeView"
        />
         <base-button
            :title="this.$t('app.tasks.create_task')"
            classNames="btn btn-orange btn-sm btn-block button-rounded"
            @clicked="clickCreateTask"
          />
      </div>
    </div>
    <div class="row mt-30">
      <div class="col-sm-3">
        <base-dropdown
          :list="sites"
          v-model="siteId"
          :needDefaultValue="false"
          :defaultValue="siteId"
          :inputDisabled="loggedInUser.site_id != null"
          labelClassNames="control-label mb-10 text-left"
          :labelValue="$t(`app.inspections.filter.site_id`)"
          @input="filterBySite"/>
      </div>
    </div>
    <div class="row mt-30">
      <div class="col-lg-12">
        <div class="panel panel-default card-view pa-0 task-panel">
          <div class="panel-wrapper collapse in">
            <div class="panel-body pa-0">
              <div class="mail-box">
                <div class="row" v-if="!calendarView">
                  <aside class="col-lg-6 col-md-6 pr-0">
                    <div class="panel panel-refresh pa-0">
                      <div class="panel-wrapper collapse in message-list">
                        <div class="panel-body inbox-body pa-0">
                            <tasks-inbox-table
                              :list="allTask"
                              :selectedTaskId="selectedTaskId"
                              @itemSelected="taskSelected"
                              :loadingText="loadingText"
                              :isLoading="isLoading"
                              @appendTasks="appendTasks"
                              />
                        </div>
                      </div>
                    </div>
                  </aside>
                  <aside class="col-lg-6 col-md-6 pl-0 list-content-wrapper">
                    <tasks-inbox-list-content
                      :task="selectedTask"
                      @sendBtnClicked="sendBtnClicked"
                      @editTaskClicked="editTaskClicked"
                      @delegateTaskClicked="delegateTaskClicked"
                      @deleteTaskClicked="deleteSelecetedTaskClicked"
                      @updateStatusClicked="updateTaskStatusClicked"
                    />
                  </aside>
                </div>
                <div class="row" v-if="calendarView">
                  <aside class="col-lg-12 col-md-12 pr-0">
                    <vue-cal :selected-date="this.today()"
                      :time-from="9 * 60"
                      :disable-views="['years', 'year', 'week', 'day']"
                      default-view="month"
                      events-on-month-view="short"
                      :locale="calendarLocale"
                      :events="tasks"
                      style="height: 720px"
                      :on-event-click="onEventClick"/>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <!-- Row -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GenericForm from '@/components/shared/forms/GenericForm';
import SearchInput from '@/components/shared/inputs/SearchInput';
import TasksInboxTable from './TasksInboxTable';
import TasksInboxList from './TasksInboxList';
import TasksInboxListContent from './TasksInboxListContent';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import PageHeader from '@/components/shared/layouts/PageHeader';
import BaseButton from '@/components/shared/buttons/BaseButton';
import VueCal from 'vue-cal';
import 'vue-cal/dist/i18n/hu.js';
import 'vue-cal/dist/i18n/sr.js';
import 'vue-cal/dist/vuecal.css';

const debounce = require('debounce');

export default {
  name: 'TasksScreen',
  components: {
    'tasks-inbox-table': TasksInboxTable,
    'tasks-inbox-list': TasksInboxList,
    'tasks-inbox-list-content': TasksInboxListContent,
    'search-input': SearchInput,
    'page-header': PageHeader,
    'base-button': BaseButton,
    BaseDropdown,
    VueCal,
  },
  props: {},
  data() {
    return {
      calendarView: false,
      tasks: [],
      currentPageIndex: 1,
      totalPages: 1,
      searchTerm: '',
      filter: 'own',
      selectedTask: null,
      newTask: {
        name: null,
        assignee_user_id: null,
        deadline: null,
        description: null,
        task_type: 'provision',
        site_id: null,
      },
      updatedTask: {
        name: null,
        assignee_user_id: null,
        deadline: null,
        description: null,
      },
      loadingText: '',
      isLoading: true,
      siteId: undefined,
      sites: [],
      selectedSite: undefined,
      allSite: [],
      allTask: []
    };
  },
  created() {
    this.loadingText = this.$t('app.listLoading');
    this.fetchSites({
      partnerId: this.loggedInUser.partner_id,
      pageIndex: null,
      searchTerm: '',
      orderInfo: {
        order: 'created_at',
        direction: 'ASC',
      },
      isMobile: true,
    }).then((r) => {
      this.allSite = r;
      if (this.loggedInUser.site_id) {
        this.sites = r.filter(x => x.id === this.loggedInUser.site_id).map(x => ({ value: x.id, text: this.$t(x.name) }));
        this.siteId = this.loggedInUser.site_id;
        this.selectedSite = r.filter(x => x.id === this.loggedInUser.site_id)[0];
      } else {
        this.sites = r.map(x => ({ value: x.id, text: this.$t(x.name) }));
        if (this.$route.query.siteId) {
          this.selectedSite = r.filter(x => x.id.toString() === this.$route.query.siteId.toString())[0];
          this.siteId = this.selectedSite.id;
        } else {
          if (this.sites.length > 0) {
            this.siteId = this.sites[0].value;
          } else {
            this.siteId = null;
          }
          this.selectedSite = r[0];
        }
      }
      this.setTasks();
      this.fetchTasks({
        pageIndex: this.currentPageIndex,
        searchTerm: this.searchTerm,
        needAll: true,
        siteId: this.siteId,
      }).then((response) => {
        this.allTask = response.tasks;
        this.totalPages = response.total_pages;
        this.isLoading = false;
      });
      if (this.$route.params.id) {
        this.fetchTask(this.$route.params.id)
          .then((task) => {
            this.selectedTask = task;
          })
          .catch((error) => {
            this.$swal
              .fire({
                html: error[0],
                type: 'error',
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                focusConfirm: false,
              });
          });
      }
    });
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
      commonData: 'partners/commonData',
      selectedLanguage: 'selectedLanguage',
    }),
    calendarLocale() {
      if (this.selectedLanguage === 'hu_HU') {
        return 'hu';
      }
      return 'en';
    },
    vivuList() {
      const mappedVivus = this.selectedSite.participants.map(user => ({
        value: user.id,
        text: user.name,
      }));
      return mappedVivus;
    },
    taskAttributes() {
      return [
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'deadline',
          type: 'date',
          classes: 'col-md-6',
        },
        {
          name: 'description',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'assignee_user_id',
          type: 'dropdown',
          dropdownList: this.vivuList,
          classes: 'col-md-6',
        },
        {
          name: 'files',
          type: 'file',
          multiple: true,
        },
      ];
    },
    workerTaskAttributes() {
      return [
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'assignee_user_id',
          type: 'dropdown',
          dropdownList: this.vivuList,
          classes: 'col-md-6',
        },
        {
          name: 'files',
          type: 'file',
          multiple: true,
        },
      ];
    },
    delegateTaskAttributes() {
      return [
        {
          name: 'assignee_user_id',
          type: 'dropdown',
          dropdownList: this.vivuList,
        },
      ];
    },
    selectedTaskId() {
      let id;
      if (this.selectedTask) {
        this.allTask.forEach((element, index) => {
          if (element.id == this.selectedTask.id) {
            id = element.id;
          }
        });
      }
      return id;
    },
  },
  methods: {
    ...mapActions({
      fetchTasks: 'tasks/fetchTasks',
      fetchCalendarTasks: 'tasks/fetchCalendarTasks',
      fetchTask: 'tasks/fetchTask',
      createNewTask: 'tasks/createTask',
      sendMessage: 'tasks/sendMessage',
      updateTaskParams: 'tasks/updateTask',
      updateTaskStatus: 'tasks/updateTaskStatus',
      deleteTask: 'tasks/deleteTask',
      fetchSites: 'sites/fetchSites',
    }),
    appendTasks() {
      if (this.currentPageIndex >= this.totalPages) {
        return;
      }
      this.currentPageIndex += 1;
      this.isLoading = true;
      this.fetchTasks({
        pageIndex: this.currentPageIndex,
        searchTerm: this.searchTerm,
        needAll: true,
        siteId: this.siteId,
      }).then((response) => {
        if (response.tasks && response.tasks.length > 0) {
          this.allTask = this.allTask.concat(response.tasks);
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
        console.error("Error loading more tasks:", error);
      });
    },
    filterBySite(site) {
      this.fetchTasks({
        pageIndex: this.currentPageIndex,
        searchTerm: this.searchTerm,
        needAll: true,
        siteId: site,
      }).then((response) => {
        this.allTask = response.tasks;
        this.totalPages = response.total_pages;
        this.selectedTask = null;
        this.siteId = site;
        this.selectedSite = this.allSite.filter(x => x.id === site)[0];
        this.setTasks();
      });
    },
    setTasks() {
      this.fetchCalendarTasks({keyword: this.searchTerm, siteId: this.siteId}).then((response) => {
        this.tasks = response.final_tasks.task_list.map((x) => {
          const date = new Date(x.deadline);
          if(!x.name && x.task_type && x.task_type === 'deflection') {
            return {
              title: this.$t('app.calendar.deflection'),
              data: {
                id: x.id,
                name: x.name === undefined || x.name === null ? this.$t('app.calendar.unset') : x.name,
                description: x.description === undefined || x.description === null ? this.$t('app.calendar.unset') : x.description,
                deadline: this.formatDate(date, true),
                identifier: x.identifier,
                type: x.type,
                site_id: x.site_id,
                task_type: x.task_type
              },
              start: this.formatDate(date),
              end: this.formatDate(date),
              class: x.status,
            }
          }
          if (!x.name && x.description) {
            return {
              title: x.description,
              data: {
                id: x.id,
                name: x.name === undefined || x.name === null ? this.$t('app.calendar.unset') : x.name,
                description: x.description === undefined || x.description === null ? this.$t('app.calendar.unset') : x.description,
                deadline: this.formatDate(date, true),
                identifier: x.identifier,
                type: x.type,
                site_id: x.site_id,
                task_type: x.task_type
              },
              start: this.formatDate(date),
              end: this.formatDate(date),
              class: x.status,
            };
          } else if (x.name) {
            return {
              title: x.name,
              data: {
                id: x.id,
                name: x.name === undefined || x.name === null ? this.$t('app.calendar.unset') : x.name,
                description: x.description === undefined || x.description === null ? this.$t('app.calendar.unset') : x.description,
                deadline: this.formatDate(date, true),
                identifier: x.identifier,
                type: x.type,
                site_id: x.site_id,
                task_type: x.task_type
              },
              start: this.formatDate(date),
              end: this.formatDate(date),
              class: x.status,
            };
          }
          return {
            title: x.identifier,
            data: {
              id: x.id,
              name: x.name === undefined || x.name === null ? this.$t('app.calendar.unset') : x.name,
              description: x.description === undefined || x.description === null ? this.$t('app.calendar.unset') : x.description,
              deadline: this.formatDate(date, true),
              identifier: x.identifier,
              type: x.type,
              site_id: x.site_id,
              task_type: x.task_type
            },
            start: this.formatDate(date),
            end: this.formatDate(date),
            class: x.status,
          };
        });
      });
    },
    today() {
      return new Date();
    },
    onEventClick(event) {
      console.log(this.loggedInUser.role)
      if (event.data.id === 0 && event.data.type === 0) {
        this.$swal
          .fire({
            html: '',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: this.loggedInUser.role != 'worker',
            focusConfirm: false,
            confirmButtonText: this.$t('app.calendar.goToInspections'),
            cancelButtonText: this.$t('app.calendar.goToTasks')
          })
          .then((result) => {
            if (result.value) {
              this.$router.push({
                name: 'InspectionsScreen',
              });
            } else if (result.dismiss && result.dismiss === 'cancel') {
              this.calendarView = false;
            }
          });
      } else if (event.data.id === 0 && event.data.type === 1) {
        this.$router.push({ name: 'InspectionsScreen' });
      } else if (event.data.id === 0 && event.data.type === 2) {
        this.calendarView = false;
      } else if (event.data.type === 1) {
      console.log(event.data)
        this.$swal
          .fire({
            html: `<p class="name"><span class="title">${this.$t(
              'app.calendar.type',
            )}</span> ${this.$t('app.calendar.inspection')}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.identifier',
  )}</span> ${event.data.identifier}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.description',
  )}</span> ${event.data.description}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.deadline',
  )}</span> ${event.data.deadline}<p>`,
            type: 'info',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: this.loggedInUser.role != 'worker',
            focusConfirm: false,
            confirmButtonText: this.$t('app.calendar.goToInspections'),
          })
          .then((result) => {
            if (result.value) {
              this.$router.push({
                name: 'InspectionsScreen',
              });
            }
          });
      } else {
        this.$swal
          .fire({
            html: `<p class="name"><span class="title">${this.$t(
              'app.calendar.type',
            )}</span> ${event.data.task_type === 'deflection' ? this.$t('app.calendar.deflection') : this.$t('app.calendar.provision')}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.identifier',
  )}</span> ${event.data.identifier}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.description',
  )}</span> ${event.data.description}<p>
              <p class="name"><span class="title">${this.$t(
    'app.calendar.deadline',
  )}</span> ${event.data.deadline}<p>`,
            type: 'info',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('app.calendar.goToTasks'),
          })
          .then((result) => {
            if (result.value) {
              this.calendarView = false;
            }
          });
      }
    },
    formatDate(d, withoutTime) {
      if (withoutTime) {
        return [
          d.getFullYear(),
          (`0${d.getMonth() + 1}`).slice(-2),
          d.getDate(),
        ].join('-');
      }
      return `${[
        d.getFullYear(),
        d.getMonth() + 1,
        d.getDate(),
      ].join('-')} ${
        [
          d.getHours(),
          d.getMinutes(),
        ].join(':')}`;
    },
    changeView() {
      this.calendarView = !this.calendarView;
    },
    clickCreateTask() {
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.tasks.set_task'),
          fields: this.taskAttributes,
          model: this.newTask,
          submitTitle: this.$t('app.tasks.buttons.save'),
          cancelTitle: this.$t('app.tasks.buttons.cancel'),
          modelName: 'tasks',
        },
        on: {
          submit: this.createTask,
          modalCanceled: this.resetNewTask,
        },
        width: '1000px',
      });
    },
    createTask(newTask) {
      this.createNewTask({ params: newTask, siteId: this.siteId })
        .then(() => {
          this.setTasks();
          this.fetchTasks({
            pageIndex: 1,
            searchTerm: this.searchTerm,
            siteId: this.siteId,
            needAll: true,
          })
            .then((response) => {
              this.allTask = response.tasks
              this.resetNewTask();
              this.$eventBus.hideModal();
            })
            .catch((error) => {
              this.$swal
                .fire({
                  html: error[0],
                  type: 'error',
                  showCloseButton: true,
                  showCancelButton: false,
                  showConfirmButton: false,
                  focusConfirm: false,
                });
            });
        })
        .catch(() => {
          this.$eventBus.stopLoading();
          this.$eventBus.getError([this.$t('app.tasks.create_error')]);
        });
    },
    resetNewTask() {
      Object.assign(this.$data.newTask, this.$options.data().newTask);
    },

    // eslint-disable-next-line func-names
    search: debounce(function (newTerm) {
      this.searchTerm = newTerm;
      this.currentPageIndex = 1;
      this.fetchTasks({
        pageIndex: this.currentPageIndex,
        searchTerm: this.searchTerm,
        needAll: true,
        siteId: this.siteId,
      }).then((response) => {
        this.allTask = response.tasks;
        this.totalPages = response.total_pages;
        this.setTasks();
      });
    }, 200),

    filterChanged(filter) {
      this.filter = filter;
      this.selectedTask = null;
      this.search(this.searchTerm);
    },
    taskSelected(task) {
      this.calendarView = false;
      this.selectedTask = task;
    },
    sendBtnClicked(params) {
      this.sendMessage(params).then(response => {
        this.fetchTask(params.id)
          .then((task) => {
            this.selectedTask = task;
          })
      })
    },
    editTaskClicked(id) {
      this.editTask(id);
    },
    editTask(id) {
      this.fetchTask(id)
        .then((task) => {
          const condition = this.loggedInUser.role === 'worker' && task.assignee_user_id === this.loggedInUser.id;
          this.$eventBus.showModal({
            bind: {
              is: GenericForm,
              title: this.$t('app.tasks.edit_task'),
              fields: condition ? this.workerTaskAttributes : this.taskAttributes,
              model: task,
              submitTitle: this.$t('app.tasks.buttons.save'),
              cancelTitle: this.$t('app.tasks.buttons.cancel'),
              modelName: 'tasks',
            },
            on: {
              submit: this.updateTask,
            },
            width: '1000px',
          });
        })
        .catch((error) => {
          this.$swal
            .fire({
              html: error[0],
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
    },
    updateTask(task) {
      this.updateTaskParams(task)
        .then((response) => {
          // Update the selected task
          this.selectedTask = response;
          // Update the task in allTask array
          const taskIndex = this.allTask.findIndex(task => task.id === response.id);
          console.log(taskIndex)
          console.log(this.allTask[taskIndex])
          if (taskIndex !== -1) {
            this.allTask.splice(taskIndex, 1, response);
          }
          console.log(this.allTask[taskIndex])
          // this.fetchTasks({
          //   pageIndex: this.currentPageIndex,
          //   searchTerm: this.searchTerm,
          //   needAll: true,
          //   siteId: this.siteId,
          // });
          this.setTasks();
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    delegateTaskClicked(id) {
      this.fetchTask(id)
        .then((task) => {
          this.$eventBus.showModal({
            bind: {
              is: GenericForm,
              title: this.$t('app.tasks.delegate_task'),
              fields: this.delegateTaskAttributes,
              model: task,
              submitTitle: this.$t('app.tasks.buttons.save'),
              cancelTitle: this.$t('app.tasks.buttons.cancel'),
              modelName: 'tasks',
            },
            on: {
              submit: this.updateTask,
            },
          });
        })
        .catch((error) => {
          this.$swal
            .fire({
              html: error[0],
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
    },
    deleteSelecetedTaskClicked(id) {
      this.$swal
        .fire({
          html: this.$t('app.notifications.general_confirm.title'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t('app.notifications.general_confirm.cancel'),
        })
        .then((result) => {
          if (result.value) {
            this.deleteTask(id)
              .then((response) => {
                this.setTasks();
                this.fetchTasks({
                  pageIndex: 1,
                  searchTerm: this.searchTerm,
                  siteId: this.siteId,
                  needAll: true,
                }).then((response) => {
                  this.allTask = response.tasks;
                  this.selectedTask = null;
                  this.$eventBus.showNotification({
                    notificationText: this.$t(
                      'app.notifications.tasks.deleted',
                    ),
                    notificationType: 'success',
                  });
                }).catch((error) => {
                  this.$swal
                    .fire({
                      html: error[0],
                      type: 'error',
                      showCloseButton: true,
                      showCancelButton: false,
                      showConfirmButton: false,
                      focusConfirm: false,
                    });
                });
              })
              .catch((error) => {
                this.$swal
                  .fire({
                    html: error[0],
                    type: 'error',
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    focusConfirm: false,
                  });
              });
          }
        });
    },
    updateTaskStatusClicked(payload) {
      this.updateTaskStatus(payload)
        .then((response) => {
          this.$eventBus.showNotification({
            notificationText: this.$t('app.notifications.tasks.done'),
            notificationType: 'success',
          });
          
          // Update the selected task
          this.selectedTask = response;
          
          // Update the task in allTask array
          const taskIndex = this.allTask.findIndex(task => task.id === payload.id);
          if (taskIndex !== -1) {
            this.allTask.splice(taskIndex, 1, response);
          }
          
          // Update calendar view
          this.setTasks();
        })
        .catch((error) => {
          this.$swal
            .fire({
              html: error[0],
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
    },
  },
};
</script>

<style lang="scss">
.task-screen {

  .card-view {
    margin-left: 0;
    margin-right: 0;
  }

  .task-panel {
    margin-right: 5px;
  }
  .vuecal__arrow--next {
    padding-right: 1.4em;
  }
  .vuecal__cell {
    height: 100px !important;
  }
  .button-row {
    padding-right: 20px;
  }
  .calender-button {
    cursor: pointer;
    font-size: 30px;
  }
  .mail-box {
    .panel {
      border-right: 1px solid #eee;
    }
    overflow: hidden;
  }
  .message-list {

  }
  .task-search-field {
    width: 100%;
  }
  .rounded {
    border-radius: 50%;
  }

  .button-rounded {
    border-radius: 4px;
  }

  .overflow-text {
    display: block;
    white-space: nowrap;
  }

  .increased-padding {
    cursor: pointer;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    padding-bottom: 20px !important;
    padding-top: 20px !important;
    padding-right: 0px !important;
  }

  .header-increased-padding {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    padding-right: 0px !important;
    position: absolute;
    width: 100%;
    top: 0
  }

  .content {
    margin-top: 40px;
    overflow-y: auto;
    max-height: 600px;
  }

  .increased-padding:hover {
    background: #eee;
  }

  .date-field {
    font-size: 11px;
  }

  .name-field {
    font-size: 13px;
    font-weight: bold;
  }

  .name-field-sub-text {
    font-size: 13px;
  }

  .task-alert {
    background: #ff6565;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 4px 8px 4px 8px;
    float: left;
  }

  .task-deflection {
    background: rgba(34, 175, 71, 0.85);
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 4px 8px 4px 8px;
    float: left;
  }

  .task-provision {
    background: #FFC13E;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 4px 8px 4px 8px;
    float: left;
  }

  .task-name {
    font-size: 18px;
    padding-left: 5px;
    float: left;
  }

  .flex-div-center {
    display: flex;
    align-items: center;
  }

  .profile-field {
    padding-left: 0px !important;
    padding-top: 15px;
  }

  .max-width {
    width: 100%;
  }

  .profile-avatar {
    width: 8%;
  }

  .list-profile-avatar {
    padding-right: 10px;
  }

  .profile-details {
    width: 92%;
  }

  @media (max-width: 1300px) {
    .profile-details {
      width: 87%;
      margin-left: 5%
    }
  }

  .list-content-wrapper {
    max-height: 600px;
    overflow: auto;
  }
  .aside-class {
    height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/TasksScreen.vue